module.exports = __webpack_public_path__ + "media/images/index-cover-1690ab58bc88fa05f16711ffe727939d.gif";